<template>
  <box-section class="difference-content">
    <div class="difference-inner-content">
      <header>
        <a href="#" v-on:click.prevent="back"><img src="../assets/back-arrow-dark.svg" class="back-arrow" alt=""></a>
        <h1>What’s the difference?</h1>
      </header>
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <td></td>
              <td>Audit</td>
              <td>Review</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="difference in differences" :key="difference.heading">
              <td><h5>{{ difference.heading }}</h5></td>
              <td v-html="difference.audit"></td>
              <td v-html="difference.review"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <aside class="bottom-link">
      <router-link to="/services"><span>See all our services</span><img src="../assets/forward-arrow-dark.svg" alt=""></router-link>
    </aside>
  </box-section>
</template>

<script>
import BoxSection from './BoxSection'
import axios from 'axios'

export default {
  name: 'Services',

  components: { BoxSection },

  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      differences: [],
      metaInfo: {
        title: 'What’s the difference?'
      }
    }
  },

  metaInfo () {
    return {
      title: this.metaInfo.title
    }
  },

  methods: {
    back () {
      this.$router.go(-1)
    }
  },

  mounted () {
    axios.get(process.env.ENDPOINT, {
      params: {
        slug: 'whats-the-difference'
      }
    }).then(response => {
      console.log(response)
      this.differences = response.data[0].acf.page_content
      this.metaInfo.title = response.data[0].title.rendered
      document.dispatchEvent(new Event('content-loaded'))
    }).catch(error => {
      console.log(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Difference.vue